import { Link } from "react-router-dom";
import { Instagram, Phone, Mail, MapPin } from "lucide-react";

export default function SiteFooter({ settings }) {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-[#0B0B0B] text-white/70 border-t border-white/5 mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-5">
            <img src="/assets/sk-logo.jpeg" alt="SK Group" className="w-14 h-14 rounded-full ring-1 ring-[#D4AF37]/40" />
            <div>
              <div className="font-display text-2xl text-white">SK Group</div>
              <div className="text-[11px] tracking-[0.3em] text-[#D4AF37] uppercase">Financial Services</div>
            </div>
          </div>
          <p className="max-w-md text-sm leading-relaxed">
            {settings?.tagline || "Empowering your dreams with fast, transparent loans."}
            &nbsp;A trusted lending partner offering Personal, Business, Home, Car, Gold, Education and Property loans across India.
          </p>
          <div className="mt-6 flex items-center gap-3">
            <a
              data-testid="footer-instagram"
              href={settings?.instagram_url || "https://instagram.com/sk_group_finance_"}
              target="_blank" rel="noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#D4AF37]/40 text-[#D4AF37] text-sm hover:bg-[#D4AF37]/10 transition-colors"
            >
              <Instagram size={16} /> @sk_group_finance_
            </a>
          </div>
        </div>

        <div>
          <div className="text-white text-xs tracking-[0.24em] uppercase mb-4">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/loans" className="hover:text-[#D4AF37]">Loan Products</Link></li>
            <li><Link to="/emi-calculator" className="hover:text-[#D4AF37]">EMI Calculator</Link></li>
            <li><Link to="/apply" className="hover:text-[#D4AF37]">Apply Now</Link></li>
            <li><Link to="/contact" className="hover:text-[#D4AF37]">Contact</Link></li>
            <li><Link to="/login" className="hover:text-[#D4AF37]">Customer Login</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-white text-xs tracking-[0.24em] uppercase mb-4">Reach Us</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2"><Phone size={14} className="mt-1 text-[#D4AF37]"/>{settings?.contact_phone || "+91 88661 11559"}</li>
            <li className="flex items-start gap-2"><Mail size={14} className="mt-1 text-[#D4AF37]"/>{settings?.contact_email || "care@skgrouploans.online"}</li>
            <li className="flex items-start gap-2"><MapPin size={14} className="mt-1 text-[#D4AF37]"/>{settings?.address || "206 Lakhani Chamber, near Mini Bazar Road, Surat"}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <div>© {year} SK Group Financial Services · skgrouploans.online · All rights reserved.</div>
          <div>Lending is subject to eligibility, credit assessment & internal policies.</div>
        </div>
      </div>
    </footer>
  );
}
